module.exports = __webpack_public_path__ + "static/img/facebook_circle-512.6163476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/facebook_circle-512.png
// module id = hM1d
// module chunks = 1